import { combineReducers } from 'redux';

import {
  SET_RESOLUTION_FILTERS,
  RESET_RESOLUTION_FILTERS,
  SET_RESOLUTION_GRID_SORT_CRITERIA,
} from './actionTypes';

const resolutionFiltersInitialState = {
  aggregatorID: '',
  payerID: '',
};

const resolutionGridSortCriteriaInitialState = {
  sortByColumn: '',
  sortDirection: '',
};

const resolutionFiltersReducer = (
  state = resolutionFiltersInitialState,
  { type = '', filters = { ...resolutionFiltersInitialState } } = {},
) => {
  switch (type) {
    case SET_RESOLUTION_FILTERS:
      return {
        ...state,
        ...filters,
      };

    case RESET_RESOLUTION_FILTERS:
      return {
        ...state,
        ...resolutionFiltersInitialState,
      };

    default: {
      return state;
    }
  }
};

const currentResolutionGridSortCriteriaReducer = (
  state = resolutionGridSortCriteriaInitialState,
  { type = '', sortCriteria = { ...resolutionGridSortCriteriaInitialState } } = {},
) => {
  switch (type) {
    case SET_RESOLUTION_GRID_SORT_CRITERIA:
      return {
        ...state,
        ...sortCriteria,
      };

    default:
      return state;
  }
};

const resolutionReducer = combineReducers({
  resolutionFilters: resolutionFiltersReducer,
  resolutionGridSortCriteria: currentResolutionGridSortCriteriaReducer,
});

export { resolutionReducer, resolutionFiltersInitialState, resolutionGridSortCriteriaInitialState };
